import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/multi-conversation/real-time-sync/real-time-sync.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
